<template>
  <div class="dashboard">

    <!-- Top bar -->
    <div class="dash-topbar px-6 py-4">
      <div>
        <h1 class="dash-title">Dashboard</h1>
        <p class="dash-sub">Welcome back, {{ $store.state.adminDetails.name || 'Admin' }} 👋</p>
      </div>
      <v-chip color="success" variant="tonal" size="small" prepend-icon="mdi-circle">
        System Online
      </v-chip>
    </div>

    <div class="px-6 pb-8">

      <!-- Stats row -->
      <v-row class="gy-4 mb-6">
        <v-col v-for="s in stats" :key="s.label" cols="6" sm="3">
          <v-card elevation="1" rounded="xl" class="stat-card pa-4">
            <div class="d-flex align-center justify-space-between">
              <div>
                <div class="stat-value">{{ s.value }}</div>
                <div class="stat-label">{{ s.label }}</div>
              </div>
              <v-avatar :color="s.color" size="44" rounded="lg">
                <v-icon color="white" size="22">{{ s.icon }}</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Module cards -->
      <div class="section-label mb-4">Quick Actions</div>
      <v-row class="gy-4">
        <v-col
          v-for="mod in modules" :key="mod.label"
          cols="12" sm="6" md="4" lg="3"
        >
          <v-card
            elevation="1" rounded="xl" class="module-card"
            :to="mod.to" @click="mod.action ? mod.action() : null"
            style="cursor:pointer;"
          >
            <div class="module-card-inner pa-5">
              <v-avatar :color="mod.color" size="48" rounded="xl" class="mb-3">
                <v-icon color="white" size="22">{{ mod.icon }}</v-icon>
              </v-avatar>
              <div class="module-title">{{ mod.label }}</div>
              <div class="module-desc">{{ mod.desc }}</div>
            </div>
            <div class="module-footer">
              <span>Manage</span>
              <v-icon size="14" class="ml-1">mdi-arrow-right</v-icon>
            </div>
          </v-card>
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  computed: {
    modules () {
      const base = [
        { icon: 'mdi-book-open-variant-outline', color: 'primary',    label: 'Departments',       desc: 'Manage departments & faculty',    to: '/departments' },
        { icon: 'mdi-image-multiple-outline',    color: 'indigo',     label: 'Event Gallery',     desc: 'Upload & manage event photos',    to: '/event' },
        { icon: 'mdi-image-area',               color: 'blue',       label: 'Banners',           desc: 'Update homepage banner images',   to: '/banners' },
        { icon: 'mdi-file-document-outline',    color: 'teal',       label: 'Circulars',         desc: 'Publish notices & circulars',     to: '/circulars' },
        { icon: 'mdi-account-tie-outline',      color: 'cyan',       label: 'Non-Teaching Staff',desc: 'Manage administrative staff',     to: '/non_teaching' },
        { icon: 'mdi-medal-outline',            color: 'amber',      label: 'Scholarships',      desc: 'Scholarship links & listings',    to: '/scholarships' },
        { icon: 'mdi-clipboard-check-outline',  color: 'green',      label: 'IQAC',              desc: 'Upload IQAC documents',           to: '/iqac' },
        { icon: 'mdi-file-cabinet',             color: 'orange',     label: 'General PDFs',      desc: 'Upload miscellaneous PDFs',       to: '/pdfs' },
        { icon: 'mdi-paperclip',               color: 'deep-orange',label: 'DVV Criteria',      desc: 'Manage DVV criteria files',       to: '/criteria' },
        { icon: 'mdi-logout',                  color: 'red',        label: 'Log Out',           desc: 'Sign out of admin panel',         to: null, action: this.logout },
      ]
      if (this.$store.state.adminRole === 'Super Admin') {
        base.unshift(
          { icon: 'mdi-shield-account-outline', color: 'purple',    label: 'Manage Admins',     desc: 'Add or edit admin accounts',      to: '/admins' },
          { icon: 'mdi-menu',                   color: 'blue-grey', label: 'App Menus',         desc: 'Configure website navigation',    to: '/app-menus' },
        )
      }
      return base
    },
    stats () {
      return [
        { icon: 'mdi-book-open-variant', color: 'primary',   value: '17',   label: 'Departments' },
        { icon: 'mdi-account-group',     color: 'teal',      value: '40+',  label: 'Faculty' },
        { icon: 'mdi-image-multiple',    color: 'indigo',    value: '—',    label: 'Events' },
        { icon: 'mdi-file-document',     color: 'orange',    value: '—',    label: 'Circulars' },
      ]
    },
  },
  methods: {
    logout () {
      sessionStorage.removeItem('token')
      this.$store.state.isAuthenticated = false
      this.$router.push('/login')
    },
  },
})
</script>

<style scoped>
.dashboard { background: #F4F7FF; min-height: 100vh; }

/* Top bar */
.dash-topbar {
  background: #fff;
  border-bottom: 1px solid #e8eaf6;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dash-title { font-size: 1.4rem; font-weight: 800; color: #1A237E; margin: 0; }
.dash-sub   { font-size: 0.82rem; color: #607D8B; margin: 2px 0 0 0; }

/* Stats */
.stat-card { border: 1px solid #e8eaf6; background: #fff; }
.stat-value { font-size: 1.6rem; font-weight: 800; color: #1A237E; line-height: 1.1; }
.stat-label { font-size: 0.72rem; color: #607D8B; text-transform: uppercase; letter-spacing: 0.5px; margin-top: 3px; }

/* Section label */
.section-label { font-size: 0.72rem; font-weight: 700; letter-spacing: 1.2px; text-transform: uppercase; color: #607D8B; }

/* Module cards */
.module-card {
  border: 1px solid #e8eaf6;
  background: #fff;
  transition: transform 0.18s, box-shadow 0.18s;
  display: flex;
  flex-direction: column;
  text-decoration: none;
}
.module-card:hover { transform: translateY(-3px); box-shadow: 0 8px 24px rgba(26,35,126,0.12) !important; }
.module-card-inner { flex: 1; }
.module-title { font-size: 0.92rem; font-weight: 700; color: #1A237E; }
.module-desc  { font-size: 0.75rem; color: #607D8B; margin-top: 3px; line-height: 1.5; }
.module-footer {
  display: flex;
  align-items: center;
  padding: 8px 20px;
  font-size: 0.72rem;
  font-weight: 700;
  color: #1A237E;
  background: #F4F7FF;
  border-top: 1px solid #e8eaf6;
  border-radius: 0 0 12px 12px;
}
</style>
